import { render, staticRenderFns } from "./CtaHero.vue?vue&type=template&id=fce63542&"
import script from "./CtaHero.vue?vue&type=script&lang=js&"
export * from "./CtaHero.vue?vue&type=script&lang=js&"
import style0 from "./CtaHero.vue?vue&type=style&index=0&id=fce63542&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports